<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">EDITAR DISPOSITIVO</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-combobox
                      ref="company"
                      v-model="data.company"
                      :items="itemsData"
                      :search-input.sync="search"
                      item-value="_id"
                      item-text="name"
                      label="Empresas"
                      placeholder="Digite el nombre de la empresa"
                      :disabled="isMaster == 0"
                      clearable
                      @click="clearInput"
                      :rules="nameRules"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      ref="profile"
                      v-model="data.profile"
                      :items="['post', 'pre']"
                      label="Perfil"
                      :rules="fieldRules"
                    >
                      <template slot="selection" slot-scope="{ item }">
                        {{ item == "post" ? "Postpago" : "Prepago" }}
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        {{ item == "post" ? "Postpago" : "Prepago" }}
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="nui"
                      v-model="data.nui"
                      :rules="nameRules"
                      label="NUI"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="alternateCode"
                      v-model="data.alternateCode"
                      label="Código Interno"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      ref="activate"
                      v-model="data.activate"
                      :items="[1, 0]"
                      label="Estado"
                      :rules="fieldRules"
                    >
                      <template slot="selection" slot-scope="{ item }">
                        {{ item == 1 ? "Activo" : "Inactivo" }}
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        {{ item == 1 ? "Activo" : "Inactivo" }}
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      ref="subTypeService"
                      v-model="data.subTypeService"
                      :items="['Agua', 'Gas', 'Energia', 'Seguridad']"
                      label="Tipo"
                      :rules="fieldRules"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" v-if="data.subTypeService === 'Gas'">
                    <v-select
                      ref="gasFlow"
                      v-model="data.gasFlow"
                      :items="['G 1,6', 'G 2,5', 'G 4', 'G 6', 'G 10']"
                      label="Clasificación Caudal"
                      :rules="fieldRules"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" v-if="data.subTypeService === 'Seguridad'">
                    <v-select
                      ref="typeDeviceS"
                      v-model="data.typeDeviceS"
                      :items="['Sensor de Puerta', 'Sensor de Ventana','Sensor de Gas', 'Sensor de Humo', 'Boton de Panico']"
                      label="Tipo de dispositivo"
                      :rules="fieldRules"
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="customName"
                      v-model="data.customName"
                      label="Nombre"
                      :rules="maxLength"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="tarifa"
                      v-model="valPrice"
                      label="Tarifa"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="serial"
                      v-model="data.serial"
                      :rules="nameRules"
                      label="Serial"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="manufacturer"
                      v-model="data.manufacturer"
                      :rules="nameRules"
                      label="Fabricante"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="address"
                      v-model="data.address"
                      label="Dirección"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="city"
                      v-model="data.city"
                      label="Ciudad"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="latitude"
                      v-model="data.latitude"
                      label="Latitud"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="longitude"
                      v-model="data.longitude"
                      label="Longitud"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6"  v-if="data.subTypeService !== 'Seguridad'">
                    <v-combobox
                      ref="social"
                      v-model="data.socialgroup"
                      :items="socialSelect"
                      :search-input.sync="searchSocial"
                      item-value="_id"
                      item-text="name"
                      label="Estrato"
                      placeholder="selecciona el estrato"
                      clearable
                      :rules="nameRules"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="6" md="6"  v-if="data.subTypeService !== 'Seguridad'">
                    <v-combobox
                      ref="zone"
                      v-model="data.zone"
                      :items="zoneSelect"
                      :search-input.sync="searchZone"
                      item-value="_id"
                      item-text="name"
                      label="Zona"
                      placeholder="selecciona la zona"
                      clearable
                      :rules="nameRules"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="6" md="6"  v-if="data.subTypeService !== 'Seguridad'">
                    <v-combobox
                      ref="road"
                      v-model="data.road"
                      :items="roadSelect"
                      :search-input.sync="searchRoad"
                      item-value="_id"
                      item-text="name"
                      label="Ruta"
                      placeholder="selecciona la ruta"
                      clearable
                      :rules="nameRules"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="6" md="6"  v-if="data.subTypeService !== 'Seguridad'">
                    <v-combobox
                      ref="cycle"
                      v-model="data.cycle"
                      :items="cycleSelect"
                      :search-input.sync="searchCycle"
                      item-value="_id"
                      item-text="name"
                      label="Ciclo"
                      placeholder="selecciona el ciclo"
                      clearable
                      :rules="nameRules"
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click.stop="show = false">Cerrar</v-btn>
                <v-btn
                  :disabled="!valid"
                  depressed
                  large
                  color="primary"
                  @click="validate"
                  >GUARDAR</v-btn
                >
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "DeviceEditComp",
  components: {},
  props: ["visible", "data"],
  data() {
    return {
      valid: true,
      valPrice: 0,
      serviceRule: [(v) => !!v || "El campo es requerido"],
      nameRules: [(v) => !!v || "El campo es requerido"],
      fieldRules: [(v) => v != null || "El campo es requerido"],
      maxLength: [
        (v) =>
          v.length <= 100 || "El campo no debe tener mas de 100 carácteres.",
      ],
      search: "",
      itemsData: [],
      searchSocial: "",
      itemsGroup: [],
      itemsZone: [],
      searchZone: "",
      itemsRoad: [],
      searchRoad: "",
      itemsCycle: [],
      searchCycle: "",
    };
  },
  async mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
        // Or any other way you want to close your modal
      }
    });
    await this.getJsonData();
    await this.getJsonSocial();
    await this.getJsonRoad();
    await this.getJsonCycle();
    await this.getJsonZone();
    this.$root.$on("reload", async () => {
      await this.getJsonData();
      await this.getJsonSocial();
      await this.getJsonRoad();
      await this.getJsonCycle();
      await this.getJsonZone();
    });
    if (this.data.priceConsume != undefined) {
      this.valPrice = this.data.priceConsume.valPrice;
    }
  },
  watch: {
    data(newDataValue) {
      if (newDataValue.priceConsume != undefined) {
        this.valPrice = newDataValue.priceConsume.valPrice;
      }
    },
    search: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs;
        });
      },
      deep: true,
    },
    searchSocial: {
      handler() {
        this.getJsonSocial().then((data) => {
          this.itemsGroup = data.docs;
        });
      },
      deep: true,
    },
    searchZone: {
      handler() {
        this.getJsonZone().then((data) => {
          this.itemsZone = data.docs;
        });
      },
      deep: true,
    },
    searchRoad: {
      handler() {
        this.getJsonRoad().then((data) => {
          this.itemsRoad = data.docs;
        });
      },
      deep: true,
    },
    searchCycle: {
      handler() {
        this.getJsonCycle().then((data) => {
          this.itemsCycle = data.docs;
        });
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "listCompany",
      "updateDevice",
      "listSocialGroup",
      "listCycle",
      "listRoad",
      "listZone",
      "alertSnackbar",
    ]),
    validate() {
      if (this.$refs.form.validate()) {
        this.registerForm();
      }
    },
    async clearInput() {
      //console.log(this.data.cycle);
      this.$refs.cycle.reset();
      this.$refs.road.reset();
      this.$refs.zone.reset();
      this.$refs.social.reset();
    },
    async getJsonCycle() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          // console.log('enviando', this.search)
          let idCompany =
            this.data.company != null ? this.data.company._id : null;

          axios
            .get(
              `cycle/list?page=1&search=${this.searchCycle}&company=${idCompany}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              //console.log('company', res.data)
              this.itemsCycle = res.data.docs;
              //this.totalNumberOfItems = res.data.totalDocs
              resolve(res.data);
            })
            .catch((error) => {
              //console.log(error.response.status)
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonRoad() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          // console.log('enviando', this.search)
          let idCompany =
            this.data.company != null ? this.data.company._id : null;

          axios
            .get(
              `road/list?page=1&search=${this.searchRoad}&company=${idCompany}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              //console.log('company', res.data)
              this.itemsRoad = res.data.docs;
              //this.totalNumberOfItems = res.data.totalDocs
              resolve(res.data);
            })
            .catch((error) => {
              //console.log(error.response.status)
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonZone() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          // console.log('enviando', this.search)
          let idCompany =
            this.data.company != null ? this.data.company._id : null;

          axios
            .get(
              `zone/list?page=1&search=${this.searchZone}&company=${idCompany}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              //console.log('company', res.data)
              this.itemsZone = res.data.docs;
              //this.totalNumberOfItems = res.data.totalDocs
              resolve(res.data);
            })
            .catch((error) => {
              //console.log(error.response.status)
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonSocial() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          // console.log('enviando', this.search)
          let idCompany =
            this.data.company != null ? this.data.company._id : null;
          axios
            .get(
              `socialgroup/list?page=1&search=${this.searchSocial}&company=${idCompany}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              //console.log("estrato", res.data);
              this.itemsGroup = res.data.docs;
              //this.totalNumberOfItems = res.data.totalDocs
              resolve(res.data);
            })
            .catch((error) => {
              //console.log(error.response.status)
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          axios
            .get(`company/list?page=1&search=${this.search}`, {
              headers: headerToken,
            })
            .then((res) => {
              this.itemsData = res.data.docs;
              this.totalNumberOfItems = res.data.totalDocs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async registerForm() {
      try {
        let form = {
          _id: this.data._id,
          company: this.data.company,
          "priceConsume.valPrice": this.valPrice,
          "priceConsume.createdAt": Date.now(),
          serial: this.data.serial,
          nui: this.data.nui,
          alternateCode: this.data.alternateCode,
          customName: this.data.customName,
          subTypeService: this.data.subTypeService,
          gasFlow: this.data.subTypeService === 'Gas' ? this.data.gasFlow : null,
          typeDeviceS: this.data.subTypeService === 'Seguridad' ? this.data.typeDeviceS : null,
          profile: this.data.profile,
          address: this.data.address,
          city: this.data.city,
          latitude: this.data.latitude,
          longitude: this.data.longitude,
          socialgroup: this.data.socialgroup,
          zone: this.data.zone,
          road: this.data.road,
          cycle: this.data.cycle,
          manufacturer: this.data.manufacturer,
          activate: this.data.activate,
        };
        let update = await this.updateDevice(form);
        if (update == 200) {
          this.alertSnackbar({
            snackbar: true,
            text: "El Dispositivo se ha actualizado.",
          });
          this.$refs.form.reset();
          this.$root.$emit("reload"); // parametro update tabla
          this.show = false;
        }
      } catch (error) {
        this.alertSnackbar({
          snackbar: true,
          text: "ocurrio un error inesperado.",
        });
      }
    },
  },
  computed: {
    ...mapGetters([
      "isMaster",
    ]),
    socialSelect() {
      let filt = this.itemsGroup
        .map((item) => {
          if (this.data.company != null) {
            if (typeof this.data.company != "object") {
              if (item.company._id === this.data.company) {
                return item;
              }
            } else {
              if (item.company._id === this.data.company._id) {
                return item;
              }
            }
          } else {
            return null;
          }
        })
        .filter((item) => {
          return item;
        });
      return filt;
    },
    zoneSelect() {
      let filt = this.itemsZone
        .map((item) => {
          if (this.data.company != null) {
            if (typeof this.data.company != "object") {
              if (item.company._id === this.data.company) {
                return item;
              }
            } else {
              if (item.company._id === this.data.company._id) {
                return item;
              }
            }
          } else {
            return null;
          }
        })
        .filter((item) => {
          return item;
        });
      return filt;
    },
    cycleSelect() {
      let filt = this.itemsCycle
        .map((item) => {
          if (this.data.company != null) {
            if (typeof this.data.company != "object") {
              if (item.company._id === this.data.company) {
                return item;
              }
            } else {
              if (item.company._id === this.data.company._id) {
                return item;
              }
            }
          } else {
            return null;
          }
        })
        .filter((item) => {
          return item;
        });
      return filt;
    },
    roadSelect() {
      let filt = this.itemsRoad
        .map((item) => {
          if (this.data.company != null) {
            if (typeof this.data.company != "object") {
              if (item.company._id === this.data.company) {
                return item;
              }
            } else {
              if (item.company._id === this.data.company._id) {
                return item;
              }
            }
          } else {
            return null;
          }
        })
        .filter((item) => {
          return item;
        });
      return filt;
    },
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset();
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
</style>
